module.exports = __webpack_public_path__ + "media/images/result_sets/circles/9n8n3r6r-7c4fc00d3865177259a96ad456bcda0d.svg";